module.exports = __webpack_public_path__ + "img/6.c7d0c8be.jpg";